import React from "react";
import moment from "moment";
import { serverFormatWithTimezone } from "../../../utils/dates";

const DATE_FORMAT = "MM/DD/yyyy hh:mm A";

const formatDateTime = dateTime => {
  return moment(dateTime, serverFormatWithTimezone).format(DATE_FORMAT);
};

export default ({ value }) => <span>{formatDateTime(value)}</span>;
